import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutServiceTransitTimeList extends Layout {
    layoutheaderSTTList: LayoutHeader;
    sourceServiceTransitTime: DataSource;
    tableServiceTransitTime: Table;
}
